import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import { MuiOtpInput } from "mui-one-time-password-input";

import { VerifyUserMPin } from "../../api/userAuth";
import { loginSuccess } from "../../features/authSlice";
import { useNotify } from "../../context/NotifyContext";
import socket from "../../socket/socket";
import { useThemeMode } from "../../context/ThemeContext";
import AuthShell from "../../components/auth/AuthShell";
import { authOtpFieldProps, authOtpSx } from "../../components/auth/AuthField";
import { useRef } from "react";
import { useEffect } from "react";

const LoginForm = () => {
  const { notify } = useNotify();
  const { setMode } = useThemeMode();
  const otpRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { username } = useParams();

  const [form, setForm] = useState({ mpin: "" });
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
  const timer = setTimeout(() => {
    otpRef.current?.focus?.();
  }, 300);

  return () => clearTimeout(timer);
}, []);

  const handleSubmit = async (e, mpinValue) => {
    if (e?.preventDefault) e.preventDefault();
    const mpin = mpinValue ?? form.mpin;

    if (!/^\d{6}$/.test(mpin)) {
      notify("MPIN must be 6 digits!", "warning");
      return;
    }

    try {
      setLoading(true);
      const payload = { userName: username, mpin };
      const result = await VerifyUserMPin(payload);

      if (result.success) {
        dispatch(
          loginSuccess({ userInfo: result.data.user })
        );
        notify("Login Successful!", "success");

        socket.emit("join", {
          userId: result.data.user._id,
          portal: "merchant",
        });

        setMode("light");
        localStorage.setItem("theme", "light");
        document.documentElement.classList.remove("dark");
        document.documentElement.classList.add("light");
        navigate("/dashboard");
      } else {
        navigate("/");
        notify(result?.message || "Login failed!", "error");
      }
    } catch {
      notify("Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Welcome back"
      title="Enter your MPIN"
      subtitle={username ? `Signed in as ${String(username).toUpperCase()}` : undefined}
    >
      <Box component="form" onSubmit={handleSubmit} noValidate autoComplete="off">
        {/* <MuiOtpInput
          length={6}
          value={form.mpin}
          autoFocus
          onChange={(val) => {
            const clean = val.replace(/\D/g, "");
            setForm({ ...form, mpin: clean });
            if (clean.length === 6) {
              setTimeout(() => handleSubmit(null, clean), 400);
            }
          }}
          inputMode="numeric"
          type="password"
          sx={authOtpSx}
          TextFieldsProps={authOtpFieldProps}
        /> */}
        <MuiOtpInput
  ref={otpRef}
  length={6}
  value={form.mpin}
  autoFocus
  onChange={(val) => {
    const clean = val.replace(/\D/g, "");
    setForm({ ...form, mpin: clean });

    if (clean.length === 6) {
      setTimeout(() => handleSubmit(null, clean), 400);
    }
  }}
  inputMode="numeric"
  type="password"
  sx={authOtpSx}
  TextFieldsProps={authOtpFieldProps}
/>

        <div className="ds-auth-row mt-3 mb-4">
          <label className="ds-auth-check">
            <input
              type="checkbox"
              checked={remember}
              onChange={() => setRemember(!remember)}
            />
            Remember me
          </label>
          <button
            type="button"
            className="ds-auth-link"
            onClick={() => navigate("/reset-password?from=login")}
          >
            Forgot MPIN?
          </button>
        </div>

        <button
          type="submit"
          className="ds-btn ds-btn-primary ds-btn-block"
          disabled={loading || form.mpin.length !== 6}
        >
          {loading ? "Verifying..." : "Continue"}
        </button>
      </Box>
    </AuthShell>
  );
};

export default LoginForm;
